






















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { OrderCount } from '@/api/model/order-count'
const orders = namespace('orders')

@Component
export default class OrderStatusTabs extends Vue {
    @orders.State readonly orderCounts!: OrderCount
}
